//LOCAL
import { Radio, Button, TextField, Checkbox, Paper, DialogContentText, DialogTitle, DialogContent, Grid, Box } from "@mui/material";
import { fontSize, styled } from "@mui/system";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IMaskInput } from 'react-imask';
import { DateField } from "@mui/x-date-pickers";
import '../assets/fonts/fonts.css';
import square from '../assets/images/square.png';


//Styled Components
export const LoginInput = styled(TextField)({
  width: '19em',
  height: '4.2em',
  '& label.Mui-focused': {
    color: '#787777'
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: '#787777'
    }
  },
});
export const FormText = styled('div')({
  height: '4.2em',
  '& label.Mui-focused': {
    color: '#787777'
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: '#787777'
    }
  },
});

export const SixBoxGridContainer = styled(Grid)({
  display: "grid",
  gridTemplateColumns: "repeat(1, 1fr)",
  gap: "10px",
  justifyContent: "center",
  justifyItems: "center",
});

export const SixBoxGridItem = styled(Box)({
  backgroundColor: "#f9f9f9",
  border: "1px solid #ddd",
  padding: "5px",
  height: "25px",
  width: "288px",
});

export const Partitioned = styled("input")({
  "&::selection": {
    background: "transparent",
  },

  letterSpacing: "42px",
  border: "0",
  backgroundImage: `url(${square})`,
  backgroundPosition: "bottom",
  backgroundSize: "50px 40px",
  backgroundRepeat: "repeat-x",
  backgroundPositionX: "45px",
  backgroundPositionY: "2px",
  minWidth: "305px",
  outline:"none",
  font: "inherit",
  paddingLeft:"13px",
  paddingTop: "10px",
  paddingBottom: "11px"
});

export const DivInner = styled("div")({
  left: 0,
  position: "sticky",
});

export const DivOuter = styled("div")({
  width: "290px",
  overflow: "hidden",
});

export const SixBoxError = styled("div")({
  color: '#ff0000',
  fontSize: '14px',
  fontWeight: 500,
})

export const SmallStyledInput= styled(TextField)({
  "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button":
  {
    WebkitAppearance: "none",
    margin: 0,
  },
})


export const DateInput = styled(DateField)({
  width: '19em',
  marginBottom: '15px',
  '& label.Mui-focused': {
    color: '#787777'
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: '#787777'
    }
  },
});

export const LoginButton = styled(Button)({
  width: '20em',
  borderRadius: '6px',
  letterSpacing: '.8px',
  fontFamily: 'Poppins',
  '&.MuiButton-contained': {
    backgroundColor: "#03a12b",
    textTransform: 'none'
  },
  '&:hover': {
    backgroundColor: '#009125',
  },
  '&:disabled': {
    backgroundColor: '#023A10',
    color: '#FFF'
  },
});

export const RememberMe = styled('div')({
  display: 'flex',
  alignSelf: 'flex-start'
})

export const CheckBox = styled(Checkbox)({
  width: 20,
  height: 10,
  color: '#787777',
  '&.Mui-checked': {
    color: '#03a12b',
  },
})

export const LoginHeading = styled('div')({
  padding: '20px 0px'
})


export const LoginPaper = styled(Paper)({
  padding: 0,
  width: 350,
  boxShadow: 'none'
})

export const LoginForm = styled("form")({
});

export const ModalCloseBtn = styled(Button)({
  height: '45px'
})
export const ModalErrorMessage = styled(DialogContentText)({
  display: "flex",
  paddingLeft: "24px",
  top: "50px",
  alignItems: "center"
})
export const ErrorIcon = styled('div')({
  maxWidth: '50px',
  maxHeight: "50px",
  display: "flex",
  position: "sticky",
  justifyContent: "center"
})
export const ModalBody = styled("div")({
  display: 'flex',
  width: '325px',
})
export const ModalTitleBar = styled(DialogTitle)({
  padding: "0px ",
  fontSize: "13px",
  height: "35px",
  color: "White",
  position: "sticky",
  top: "0px",
  display: "flex",
  justifyContent: "space-between"
})
export const ModalTitleContent = styled("div")({
  display: "flex",
  paddingLeft: "15px",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "15px"
})
export const ModalTitleClose = styled("div")({
  display: "flex",
  justifyContent: "center",
  paddingRight: "15px",
  alignItems: "center",
})
export const ModalTitleCloseIcon = styled(FontAwesomeIcon)({
  '&:hover': {
    color: "#090909",
    cursor: "pointer"
  }
})
export const ModalContent = styled(DialogContent)({
  paddingTop: "20px",
  paddingBottom: "0px"
})

type InputProps = {
  customcolor: string;
};

export const ModalButton = styled(Button) <InputProps>`
  width: 6em;
  border-radius: 10px;
  box-shadow: none;
  background-color: transparent;
  border: 1px solid;
  color: ${({ customcolor }) => customcolor};
  &:hover {
    background-color: ${({ customcolor }) => customcolor};
    color: #fff;
  }
`;
export const ModalIconSpace = styled("div")({
  display: "flex",
  width: "60px",
  justifyContent: "center",
  alignItems: "center"
})

export const Loading = styled("div")({
  paddingLeft: "10px",
  paddingBottom: "15px",
  height: "10px"
})

export const HiddenID = styled("span")({
  display: "None",
})

export const MessageContainer = styled("div")({
  margin: "0px 16px 0px 20px",
  fontSize: "14px",
  fontWeight: "500",
  color: "#ff0000"
})

type OptionContainerProps={
  shadowColor: string;
  borderThickness: string;
}

export const OptionButton = styled('button')({
  border: "none", 
  background: "none", 
  cursor: "pointer",
  padding: '0',
  marginBottom: '14px'
});

export const OptionContainer = styled("div")<OptionContainerProps>(({ shadowColor,  borderThickness }) => ({
  border: `${borderThickness} solid ${shadowColor}`,
  borderRadius: "8px",
  width: '19em',
  padding:"10px 20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position:"relative",
  margin: "0 auto",
}));

export const Option = styled('div')({
  display:'flex', 
  flexDirection: "column",
  justifyContent:'center', 
  gap: "4px"
})

export const OptionLabel = styled('div')({
  fontWeight: 'bold',
  fontSize: '16px',
  marginRight:'auto' 
})

export const OptionInfo = styled('div')({
  display: "flex", 
  alignItems: "flex-end", 
  gap:'10px', 
  marginRight:'auto'
})

export const DisabledTextField = styled(TextField)({
  '& .MuiInput-underline:before': {
    borderBottomStyle: 'solid',
  },
  '& .Mui-disabled': {
    opacity: 0.9,
    fontSize: '14px',
  },
});

export const FormHeading = styled("h4")({
  fontFamily: 'Poppins',
  marginTop: '0px'
});